import { faBox, faHome, faSearch } from "@fortawesome/free-solid-svg-icons";
import type { MenuOptionsProps } from "../menu-options/types";

export const menuOptions: MenuOptionsProps[] = [
    { icon: faHome, label: "Início", url: "/" },
    { icon: faBox, label: "Produtos", url: "/produtos" },
    { icon: faSearch, label: "Buscar", url: "/produtos" },
];